import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table } from 'react-bootstrap';
import Moment from 'react-moment';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import SvgIcon from 'react-icons-kit';
import Loader from 'react-loader-spinner';
import swal from 'sweetalert';
var Config = require('../../config');

class ModalCenter extends Component{
	constructor(props, context) {
		super(props, context);

		this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getInstitution = this.getInstitution.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
        this.showCtrlError = this.showCtrlError.bind(this);
        
		this.state = {
            show: false,
            center_name:"",
            center_type:"",
            entity_type:"",
            state:"",
            institytion:"",
            institutions:[],
            types:[],
            entities:[],
            states:[]
		};
	}

	componentDidMount() {
        this.props.onRef(this);
        
        fetch(Config.default.apiGateway.URL+'lookups_level2?type=institution_type&option=parents', {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg,'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({types: response});
            }
        });

        fetch(Config.default.apiGateway.URL+'lookups?type=center_type&notRender=0', {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg,'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({entities: response});
            }
        });

        fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents', {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg,'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({states: response});
            }
        });
    }
    
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow() {
		this.setState({ show: true });
    }
    
    getInstitution(type){
        fetch(Config.default.apiGateway.URL+'lookups_level2?type='+type+'&option=parents', {
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg,'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({institutions: response});
            }
        });
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'center_type' && e.target.value !== ""){
            this.getInstitution(e.target.value);
        }
    }

    onSave(){
        var obj = {
            health_facility_id: sessionStorage.getItem('health_facilities_id'),
            center_name: this.state.center_name,
            center_type: this.state.institution,
            entity_type: this.state.entity_type,
            state: this.state.state
        };

        if(this.isValidForm()){
            this.props.waiting.handleShow('Guardando...');
            fetch(Config.default.apiGateway.URL+'national_centers/associate', {
                method:'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'        : 'application/json',
                    'Content-Type'  : 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg)=>{
                        swal('Error', msg,'error');
                    });
                }
            }).then(response => {
                if(response !== undefined){
                    this.props.refresh();
                    this.handleClose();
                }
            });
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    isValidForm() {
        const select = document.querySelector('div.modal-centers');
		const inputs = select.querySelectorAll('input, select');
		//const inputs = document.querySelectorAll('select,input,textarea');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
	    	
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
                if (!isInputValid) {
                    vacio = true;
                }
            }
	    	

	    });

	    if(vacio){
	    	isFormValid = false;
	    }


	    return isFormValid;
    }
    
    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(this.state[refName] === undefined){
			if(control !== null){
				if(control.required){
					if(control.value === ""){
						control.classList.add('error');
			        	res = false;
			        	
					}else{
						if(control.className.includes('error')){
							control.classList.remove('error');	
						}
						res = true;
					}
				}
		    }
			
		}else if (this.state[refName] === "") {
	        if(control !== null){
	        	if(control.value === ""){
	           		control.classList.add('error');
	           		res = false;
	           	}else{
	           		if(control.className.includes('error')){
						control.classList.remove('error');
					}
					res = true;
					
	           	}
	        }
			
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
		    	res = true;
	    	}
			
		}

		return res;
		
    }
    
	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Registro de Centro</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
                    <div className="row modal-centers">
                        <div className="col-xs-12 form-group">
                            <div className="col-xs-12">
                                <span className="span-min">Nombre</span>
                                <input name="center_name" id="center_name" value={this.state.center_name}
                                    onChange={(e)=>this.handleChange(e)} required
                                    className="form-control input-sm" />
                            </div>
                            <div className="col-xs-12">
                                <span className="span-min">Tipo de Institución</span>
                                <select name="center_type" id="center_type" value={this.state.center_type}
                                    onChange={(e)=>this.handleChange(e)} required
                                    className="form-control input-sm">
                                    <option value="">Seleccione..</option>
                                    {this.state.types.map((type, i)=>
                                        <option key={i} value={type.key}>{type.value_name}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-xs-12">
                                <span className="span-min">Institución</span>
                                <select name="institution" id="institution" value={this.state.institution}
                                    onChange={(e)=>this.handleChange(e)} required
                                    className="form-control input-sm">
                                    <option value="">Seleccione..</option>
                                    {this.state.institutions.map((item, i)=>
                                        <option key={i} value={item.key}>{item.value_name}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-xs-12">
                                <span className="span-min">Tipo de Entidad</span>
                                <select name="entity_type" id="entity_type" value={this.state.entity_type}
                                    onChange={(e)=>this.handleChange(e)} required
                                    className="form-control input-sm">
                                    <option value="">Seleccione..</option>
                                    {this.state.entities.map((item, i)=>
                                        <option key={i} value={item.key}>{item.name}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-xs-12">
                                <span className="span-min">Estado</span>
                                <select name="state" id="state" value={this.state.state}
                                    onChange={(e)=>this.handleChange(e)} required
                                    className="form-control input-sm">
                                    <option value="">Seleccione..</option>
                                    {this.state.states.map((item, i)=>
                                        <option key={i} value={item.value_name}>{item.value_name}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
                    <FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onSave}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalCenter) 